module.exports = __webpack_public_path__ + "static/media/hands-heart.97eaac61.svg";